<template>
  <section>
    <!-- Header -->
    <left-menu />

    <button-back :btnRoute="'/lista-de-solicitacao'"/>

    <div id="mainContent" class="fit-requested-content">

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">{{requestAd.dateSolicitation}}</h1>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
          <div class="row">
            <!-- Profile -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 box-profile">
                <div class="col-xs-12 col-sm-12 col-md-12 offset-top-20">
                  <!-- Loading -->
                  <div v-if="loading" class="loader-page-content">
                    <div class="spinner">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>

                  <!-- Foto usuário -->
                  <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-2 user-photo">
                    <img v-if="!requestAd.photo" src="../../../../assets/img/user-default.png" class="img-responsive" alt="user">
                    <img v-if="requestAd.photo" v-bind:src="requestAd.photo" class="img-responsive" alt="user">
                    <p class="delete-photo offset-top-10">
                      <span><a v-bind:href="'/perfil/3/' + requestAd.uid" target="_blank">Acessar perfil</a></span>
                    </p>
                  </div>

                  <!-- Dados usuário -->
                  <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-10 user-detail">
                    <div class="col-xs-12 col-sm-12" v-bind:class="{'col-md-6': requestAd.imageUri, 'col-md-10': !requestAd.imageUri}">
                      <p class="name">{{requestAd.name}} - <span>{{requestAd.email}}</span></p>
                      <p><strong>Tipo da solicitação: </strong>
                        <span v-if="requestAd.userPointAdjustmentType === 1">Ajuste</span>
                        <span v-if="requestAd.isAbonoAllDay && requestAd.userPointAdjustmentType === 2">Abono para o dia todo</span>
                        <span v-if="!requestAd.isAbonoAllDay && requestAd.userPointAdjustmentType === 2">Parcial</span>
                      </p>
                      <p><strong>Total solicitado: </strong><span>{{requestAd.totalSolicited}} horas</span></p>

                      <p v-if="requestAd.partialDates"><strong>Data e hora solicitada: </strong><span>{{requestAd.partialDates}}</span></p>
                      <p v-if="requestAd.reason"><strong>Motivo da solicitação: </strong><span>{{requestAd.reason}}</span></p>
                      <p v-if="requestAd.disapprovedReason"><strong>Motivo da reprovação: </strong><span>{{requestAd.disapprovedReason}}</span></p>

                      <a v-if="requestAd" v-bind:href="'/detalhes-do-dia/3/' + requestAd.userPointDayId" target="_blank" class="empty-decoration"><span class="link">Visualizar detalhes do dia</span></a>
                    </div>

                    <div v-if="requestAd.imageUri" class="col-xs-12 col-sm-12 col-md-3 anexo">
                      <p>Anexo</p>
                      <img v-bind:src="requestAd.imageUri" class="img-responsive" alt="img anexo">
                      <a v-bind:href="requestAd.imageUri" target="_blank"><span class="link">Visualizar</span></a>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-2 status">
                      <p v-if="requestAd.userPointAdjustmentStatus === 1" class="request">Solicitado</p>
                      <p v-if="requestAd.userPointAdjustmentStatus === 2" class="green">Aprovado</p>
                      <p v-if="requestAd.userPointAdjustmentStatus === 3" class="red">Reprovado</p>
                    </div>
                  </div>

                  <div v-if="requestAd.userPointAdjustmentStatus === 1 && !loading" class="col-xs-12 col-sm-12 col-md-12 offset-top-20 action">
                    <p class="title-text">Deseja aprovar essa solicitação de ajuste?</p>
                    <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                      <div class="radio-box">
                        <input v-model="checkRadio" type="radio" name="toStatus" value="true">
                        <label>SIM</label>
                      </div>
                      <div class="radio-box">
                        <input v-model="checkRadio" type="radio" name="toStatus" value="false">
                        <label>NÃO</label>
                      </div>
                    </div>
                    <div v-if="$v.checkRadio.$error" class="required-field">
                      <span class="error-msg">Selecione se deseja aprovar ou reprovar.</span>
                    </div>

                    <div v-if="dataStatus.toStatus === 3" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-10">
                      <div class="col-md-4 padding-null">
                        <div class="form-group">
                          <textarea v-model="dataStatus.disapprovedReason" class="form-control" placeholder="Qual motivo da reprovação?" name="obs"></textarea>
                          <div v-if="disapprovedReasonRequired" class="required-field">
                            <span class="error-msg">Observação obrigatória.</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-12 offset-top-10">
                      <div class="checkbox ml10">
                        <input type="checkbox" v-model="dataStatus.sendEmail">
                        <label v-on:click="dataStatus.sendEmail = !dataStatus.sendEmail">Deseja notificar o funcionário por e-mail da atualização deste ajuste?</label>
                      </div>
                    </div>

                    <div v-if="dataStatus.sendEmail" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-10">
                      <div class="col-md-4 padding-null">
                        <div class="form-group">
                          <textarea v-model="dataStatus.messageFromAdm" class="form-control" placeholder="Deseja escrever alguma mensagem no e-mail para o funcionário?" name="msg"></textarea>
                        </div>
                      </div>
                    </div>

                    <!-- Button Search -->
                    <div class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-10">
                      <button v-if="requestAd.userPointAdjustmentStatus === 1" v-on:click="changeStatus()" v-bind:disabled="loadingSend" v-bind:class="{disable: loadingSend}" class="default-btn-bue" type="button">
                        <span v-if="!loadingSend">Confirmar</span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- History -->
            <div v-if="requestAd.userPointAdjustmentType === 1 && !loading" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30">
              <div class="col-xs-12 col-sm-6 col-md-6 padding-left-null">
                <div class="col-xs-12 col-sm-12 col-md-12 box-request-ad">
                  <p class="text">Antes</p>
                  <hr>

                  <div v-for="od in requestAd.oldDates">
                    <p>{{od.date | formatDateHoursSeconds}}</p>
                  </div>

                  <p v-if="!requestAd.oldDates.length">Nenhum ponto registrado anteriormente</p>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 padding-right-null">
                <div class="col-xs-12 col-sm-12 col-md-12 box-request-ad">
                  <p class="text">Depois</p>
                  <hr>

                  <div v-for="nd in requestAd.newDates">
                    <p v-if="nd.isEdited"><strong>{{nd.date | formatDateHoursSeconds}} </strong>(Ponto alterado)</p>
                    <p v-else>{{nd.date | formatDateHoursSeconds}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue'
  import buttonBack from "../../components/buttonBack";

  import swal from 'sweetalert';
  import { required } from 'vuelidate/lib/validators';

  import { GET_SOLICITATION, REQUEST_UPDATE_STATUS } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import vueFooter from "../../components/footer.vue";

  export default {
    name: 'requested-fit',
    components: {
      vueFooter,
      buttonBack,
      leftMenu
    },
    data() {
      return {
        loading: false,
        loadingSend: false,
        disapprovedReasonRequired: false,
        checkRadio: '',
        requestAd: {
          photo: '',
          uid: '',
          imageUri: '',
          name: '',
          reason: '',
          isAbonoAllDay: '',
          disapprovedReason: '',
          oldDates: []

        },
        dataStatus: {
          toStatus: 0,
          sendEmail: false,
          userPointAdjustmentId: this.$route.params.idSolicitation,
          messageFromAdm: "",
          disapprovedReason: "",
          deviceId: "",
          version: "",
          deviceModel: ""
        }
      }
    },
    methods: {
      getSolicitation() {
        this.loading = true;
        REQUEST_SERVICE.get(GET_SOLICITATION + "?id=" + this.$route.params.idSolicitation).then((response) => {
          UTIL_SERVICE.console("RESULT GET_SOLICITATION:", response.data);

          this.requestAd = response.data;
          if (response.data.oldDates === null)
            this.requestAd.oldDates = [];

          this.loading = false;
        }).catch(reason => {
          this.loading = false;
        });
      },
      sendRequest() {
        this.loading = true;

        try {
          let browserInfo = UTIL_SERVICE.checkBrowser();
          this.dataStatus.deviceModel = browserInfo.name;
          this.dataStatus.version = browserInfo.version;
          this.dataStatus.deviceId = JSON.parse(window.localStorage.getItem('browserId'));
        } catch (err) {}

        this.dataStatus.pointReference = this.requestAd.pointReference;

        UTIL_SERVICE.console("Data send: ", this.dataStatus);
        REQUEST_SERVICE.post(REQUEST_UPDATE_STATUS, this.dataStatus).then((response) => {
          UTIL_SERVICE.console("RESULT REQUEST_UPDATE_STATUS", response);

          this.loading = false;

          if (this.dataStatus.toStatus === 2) {
            swal("Aprovada!", "Solicitação aprovada com sucesso.", "success");
          } else if (this.dataStatus.toStatus === 3) {
            swal("Reprovada!", "Solicitação reprovada com sucesso.", "success");
          } else if (this.dataStatus.toStatus === 1) {
            swal("Sucesso!", "Solicitação enviada com sucesso.", "success");
          }

          this.$router.push({path: '/'});
        }).catch(reason => {
          this.loading = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      changeStatus() {
        this.$v.checkRadio.$touch();

        if (this.dataStatus.toStatus === 3) {
          if (!this.dataStatus.disapprovedReason) {
            this.disapprovedReasonRequired = true;
            return
          }
        } else  {
          this.disapprovedReasonRequired = true;
        }

        if (this.$v.checkRadio.$error) return;

        this.sendRequest();
      }
    },
    beforeMount(){
      this.getSolicitation();
    },
    validations: {
      dataStatus: {
        disapprovedReason: {
          required
        }
      },
      checkRadio: {
        required
      }
    },
    watch: {
      checkRadio: function (value) {
        if (value === "true") {
          this.dataStatus.toStatus = 2;
        } else {
          this.dataStatus.toStatus = 3;
        }
      },
    }
  }
</script>

<style lang="scss">
.box-request-ad {
  p {
    color: var(--defaultText) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/requestedFit/requestedFit.vue